import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

interface Menu {
  path: string
  title?: string
  children?: Menu[]
}

@Component({
  selector: 'app-content-with-sidebar',
  templateUrl: './content-with-sidebar.component.html',
  styleUrls: ['./content-with-sidebar.component.css']
})
export class ContentWithSidebarComponent {
  private subscription: Subscription;

  subTitle1: string = "";
  subTitle2: string = "";

  rootUrl: string = "";
  menus: Menu[] = [];
  

  constructor(router: Router, route: ActivatedRoute) {
    this.subscription = router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(_ => {
      const urlSegments = router.url.split("/");
      this.rootUrl = urlSegments[1];

      const childrenOfRoot = route.snapshot.routeConfig.children;
      const targetRouteConfig = childrenOfRoot?.filter(c => c.path == urlSegments[1])[0];

      this.subTitle1 = "";
      if (!targetRouteConfig.data?.hiddenSubMenu) {
        this.subTitle1 = targetRouteConfig.data?.title || urlSegments[2]?.replace(/_/gi, " ");
      }

      let hidden = targetRouteConfig.children.filter(c => c.data?.hiddenSubMenu != undefined).map(c => c.data?.hiddenSubMenu);

      if (targetRouteConfig.children == undefined || hidden.length > 0) {
        this.menus = [];
        this.subTitle2 = "";
        return;
      }

      this.subTitle2 = targetRouteConfig?.children
        .filter(p => p.path.match(/^[a-z0-9_-]+$/i) != null)
        .find(p => p.path == urlSegments[2])
        .data?.title ?? this.adjustUrl(urlSegments[3]);

      this.menus = targetRouteConfig?.children
        .filter(p => p.path.match(/^[a-z0-9_-]+$/i) != null)
        .map(p => {
          if (typeof (p.children) == "undefined") {
            return {
              path: p.path,
              title: p.data?.title
            }
          }
          else {
            return {
              path: p.path,
              title: p.data?.title,
              children: p.children.filter(c => !c.data?.hiddenSubMenu && c.path.match(/^[a-z0-9_-]+$/i) != null).map(c => ({ path: c.path, title: c.data?.title }))
            }
          }
        });
        
    });
  }

  get adjusetdRootUrl() {
    return this.adjustUrl(this.rootUrl);
  }

  adjustUrl(url: string) {
    return url?.replace(/_and_/gi, " & ").replace(/_/gi, " ").toUpperCase();
  }

  getSubTile(submenu: any) {
    return submenu?.title || this.adjustUrl(submenu.path);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
